import styled from '@emotion/styled';
import { layout, space, position, border, typography, system } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

const props = system({
    whiteSpace: true,
    transition: true,
    visibility: true,
});

export const Div = styled('div', {
    shouldForwardProp,
})(layout, space, position, border, typography, props);
